/**
 * AlmadarPostContextCompactionSLAlmadarPostContextCompactionSLPage
 *
 * Page component for AlmadarPostContextCompactionSLAlmadarPostContextCompactionSLPage
 * Path: /sl/blog/context-compaction
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostContextCompactionSLPostPageView as __AlmadarPostContextCompactionSLPostPageView } from '@/components/traits/AlmadarPostContextCompactionSLPostPageView';
import { AlmadarPostContextCompactionSLPostAnalyticsView as __AlmadarPostContextCompactionSLPostAnalyticsView } from '@/components/traits/AlmadarPostContextCompactionSLPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostContextCompactionSLAlmadarPostContextCompactionSLPageProps {
  // Add any page-level props here
}

export function AlmadarPostContextCompactionSLAlmadarPostContextCompactionSLPage(_props: AlmadarPostContextCompactionSLAlmadarPostContextCompactionSLPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostContextCompactionSLPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostContextCompactionSLPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostContextCompactionSLAlmadarPostContextCompactionSLPage;
